import { NgModule } from '@angular/core'
import { DisplayCountTenantsPipe } from './display-count-tenants.pipe'

@NgModule({
    declarations: [DisplayCountTenantsPipe],
    exports: [DisplayCountTenantsPipe],
    providers: [DisplayCountTenantsPipe],
})
export class DisplayCountTenantsModule {
}